export default __webpack_public_path__ + "a309ea1549668e2a59ff40fa787718b1.png";